import React, { Component } from 'react';

import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { Button } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DateRangeIcon from '@material-ui/icons/DateRange';

import moment from 'moment'

export default class DateRangePickers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataInicio: props.startDate != null ? moment(props.startDate).format('DD/MM/YYYY') : moment(new Date()).format('DD/MM/YYYY'),
            dataFim: props.endDate != null ? moment(props.endDate).format('DD/MM/YYYY') : moment(new Date()).format('DD/MM/YYYY')
        };
    }

    changeDate = (event, pick) => {
        this.setState({ dataInicio: pick.startDate.format('DD/MM/YYYY'), dataFim: pick.endDate.format('DD/MM/YYYY') });
        this.props.changerangedata(pick.startDate, pick.endDate)
    }


    render() {
        return (
            <DateRangePicker onApply={this.changeDate}>
                <Button
                    size="small"
                    variant="text" >
                    <DateRangeIcon style={{ width: '20px', height: '20px' }} color={'primary'} />De {this.state.dataInicio} até  {this.state.dataFim}
                </Button>
            </DateRangePicker>
        );
    }
}
